import Swiper, { Navigation, Autoplay }  from 'swiper';

const QuoteCarousel = ($, context) => {

  /* Handle direction based on breakpoint */
  var $swiper
  var currentWindowWidth = window.innerWidth
  const $target = $('.quote-carousel .swiper', context)
  const carousel = $target ? $target[0] : null
  const delay = $target.data('swiper-autoplay');

  const setSlidesHeight = () => {
    let maxHeight = 0;

    $('.swiper-slide',$target).css({height:'auto'})
    $('.swiper-wrapper', $target).css({height:'auto', maxHeight:'none'})
    /* Wait until next updated frame to recalculate heights */
    requestAnimationFrame( () => {
      $('.swiper-slide',$target).each( function(i, el) {
        const h = $(el).innerHeight()
        if(h > maxHeight) {
          maxHeight = h;
        }
      })
      /* Set new dimensions */
      $('.swiper-slide',$target).css({height: maxHeight})
      $('.swiper-wrapper',$target).css({height: maxHeight, maxHeight: maxHeight})
      /* Wait until next updated frame to ask swiper to update itself */
      requestAnimationFrame(() => $swiper.updateSize())
    })
  }

  var self = {
    init: () => {
      if(!carousel)
        return
      $swiper = new Swiper(carousel, {
        modules: [Navigation, Autoplay],
        autoplay: {
          delay: delay,
        },
        slidesPerView: 1,
        mousewheel: true,
        loop: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        speed: 800,
        on: {
          resize: function () {
            /* Only fire if window width actually changed */
            if(currentWindowWidth == window.innerWidth)
              return;
            currentWindowWidth = window.innerWidth

            /* Recalculate slider and slides heights */
            setSlidesHeight()

          },
          /* Calculate slides height */
          init: function() {
            setSlidesHeight()
          }
        }
      })
    }
  }

  return self;
}

export default QuoteCarousel